import { ChipGroup, type Option } from '@storeblocks/chip';
import { type FC } from 'react';

import { OrderValueType } from '@/api/order/models/OrderValueType';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

interface Props {
  id: string;
  dataSource: string;
  valueType: OrderValueType;
  validValueTypes: OrderValueType[];
  onChange: (valueType: string) => void;
}

export const ValueTypeSelector: FC<Props> = ({
  id,
  dataSource,
  valueType,
  validValueTypes,
  onChange,
}) => {
  const { orders } = useTexts();

  const getTrackId = useGetTrackId();
  const trackId = getTrackId('select-value-type', TrackingElement.FilterChip);

  const textMap = {
    [OrderValueType.Amount]: orders.form.valueType.amount,
    [OrderValueType.Percent]: orders.form.valueType.percent,
    [OrderValueType.Units]: orders.form.valueType.units,
  };

  const options: Option[] = validValueTypes.map((validValueType) => ({
    id: `${id}-${validValueType}`,
    label: textMap[validValueType],
    value: validValueType,
    inputProps: {
      'data-trackid': trackId,
      'data-trackid-selected-filter': validValueType,
      'data-trackid-source': dataSource,
      'data-trackid-type': 'filter-chips',
    },
  }));

  const handleOnChange = (checked: string[]): void => {
    onChange(checked[0]);
  };

  return (
    <ChipGroup
      chipVariant="choice"
      id={id}
      checked={[valueType]}
      options={options}
      onChange={handleOnChange}
    />
  );
};
